import { render, staticRenderFns } from "./Add_instruction.vue?vue&type=template&id=83c4c68e&style=height%3A100%25"
import script from "./Add_instruction.vue?vue&type=script&lang=js"
export * from "./Add_instruction.vue?vue&type=script&lang=js"
import style0 from "./Add_instruction.vue?vue&type=style&index=0&id=83c4c68e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports